//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Slider from '@material-ui/core/Slider';
//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Part
import PartMyProfileStep from './PartMyProfileStep';
import PartCheckbox from './PartCheckbox';
import PartPageTitle from './PartPageTitle';


//JSON
var profileItem = require('../data/profileItem.json');


class Comp extends React.Component {
  constructor(props) {
		super(props);

    profileItem.age　= [];
    for (let i = 18; i <= 90; i++) {
      profileItem.age.push(i);
    }

    profileItem.height　= [];
    for (let i = 120; i <= 230; i++) {
      profileItem.height.push(i);
    }

    this.state = {
      age: [18, 90],
      age_important: 0,
      region: [],
      region_important: 0,
      style: [],
      style_important: 0,
      height: [120, 230],
      height_important: 0,
      association: [],
      association_important: 0,
      marriage: [],
      marriage_important: 0,
      child: [],
      child_important: 0,
      lifestyle: [],
      lifestyle_important: 0,
      smorking: [],
      smorking_important: 0,
      drinking: [],
      drinking_important: 0,
      gambling: [],
      gambling_important: 0,
      pet: [],
      pet_important: 0,
      academic: [],
      academic_important: 0,
      job: [],
      job_important: 0,
      income: [],
      income_important: 0,
      datetime: null,
    }
	}

  componentDidMount() {
    document.title = 'プロフィール(パートナーへの希望) - パートナーズ';
    this._myProfileGet();
    if (this.props.history.action === 'PUSH') {
      window.scrollTo(0, 0);
    }
  }

  _myProfileGet() {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('item', ['profile']);
    return axios.post(config.apiUri + "member/myProfileApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      this._api2state(res.data.profile);
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }

  _api2state(profile) {
    let ageLow;
    let ageHigh;
    if (Number(profile.userdata_prof_partner_age_low) > 0 && Number(profile.userdata_prof_partner_age_high) > 0) {
      ageLow = Number(profile.userdata_prof_partner_age_low);
      ageHigh = Number(profile.userdata_prof_partner_age_high);
    }
    else if (profile.userdata_prof_partner_age_low === '問わない') {
      ageLow = 18;
      ageHigh = 90;
    }
    else {
      ageLow = profile.userdata_age - 10;
      if (ageLow < 18) {
        ageLow = 18;
      }
      ageHigh = profile.userdata_age + 10;
      if (ageHigh > 90) {
        ageHigh = 90;
      }
    }
    this.setState({age:[ageLow, ageHigh], age_important: profile.userdata_prof_partner_age_important});

    let region;
    if (profile.userdata_prof_partner_region) {
      if (profile.userdata_prof_partner_region === '問わない') {
        region = [];
      }
      else {
        region = profile.userdata_prof_partner_region.split(',');
      }
    }
    else {
      let regionMy = [profile.userdata_prof_region];
      let index = profileItem.region.findIndex((value) => value.ja === profile.userdata_prof_region);
      if (profileItem.region[index].near) {
        let regionNear = profileItem.region[index].near.split(',');
        region = [ ...regionMy, ...regionNear ];
      }
      else {
        region = [ ...regionMy ];
      }
    }
    this.setState({region:region, region_important:profile.userdata_prof_partner_region_important});


    let style;
    if (profile.userdata_prof_partner_style) {
      if (profile.userdata_prof_partner_style === '問わない') {
        style = [];
      }
      else {
        style = profile.userdata_prof_partner_style.split(',');
      }
    }
    else {
      style = [];
    }
    this.setState({style:style, style_important: profile.userdata_prof_partner_style_important});


    let heightLow;
    let heightHigh;
    if (Number(profile.userdata_prof_partner_height_low) > 0 && Number(profile.userdata_prof_partner_height_high) > 0) {
      heightLow = Number(profile.userdata_prof_partner_height_low);
      heightHigh = Number(profile.userdata_prof_partner_height_high);
    }
    else if (profile.userdata_prof_partner_height_low === '問わない') {
      heightLow = 120;
      heightHigh = 230;
    }
    else {
      heightLow = 120;
      heightHigh = 230;
    }
    this.setState({height:[heightLow, heightHigh], height_important: profile.userdata_prof_partner_height_important});

    let association;
    if (profile.userdata_prof_partner_association) {
      if (profile.userdata_prof_partner_association === '問わない') {
        association = [];
      }
      else {
        association = profile.userdata_prof_partner_association.split(',');
      }
    }
    else {
      association = [];
    }
    this.setState({association:association, association_important: profile.userdata_prof_partner_association_important});

    let marriage;
    if (profile.userdata_prof_partner_marriage) {
      if (profile.userdata_prof_partner_marriage === '問わない') {
        marriage = [];
      }
      else {
        marriage = profile.userdata_prof_partner_marriage.split(',');
      }
    }
    else {
      marriage = [];
    }
    this.setState({marriage:marriage, marriage_important: profile.userdata_prof_partner_marriage_important});


    let child;
    if (profile.userdata_prof_partner_child) {
      if (profile.userdata_prof_partner_child === '問わない') {
        child = [];
      }
      else {
        child = profile.userdata_prof_partner_child.split(',');
      }
    }
    else {
      child = [];
    }
    this.setState({child:child, child_important: profile.userdata_prof_partner_child_important});


    let lifestyle;
    if (profile.userdata_prof_partner_lifestyle) {
      if (profile.userdata_prof_partner_lifestyle === '問わない') {
        lifestyle = [];
      }
      else {
        lifestyle = profile.userdata_prof_partner_lifestyle.split(',');
      }
    }
    else {
      lifestyle = [];
    }
    this.setState({lifestyle:lifestyle, lifestyle_important: profile.userdata_prof_partner_lifestyle_important});

    let smorking;
    if (profile.userdata_prof_partner_smorking) {
      if (profile.userdata_prof_partner_smorking === '問わない') {
        smorking = [];
      }
      else {
        smorking = profile.userdata_prof_partner_smorking.split(',');
      }
    }
    else {
      smorking = [];
    }
    this.setState({smorking:smorking, smorking_important: profile.userdata_prof_partner_smorking_important});


    let drinking;
    if (profile.userdata_prof_partner_drinking) {
      if (profile.userdata_prof_partner_drinking === '問わない') {
        drinking = [];
      }
      else {
        drinking = profile.userdata_prof_partner_drinking.split(',');
      }
    }
    else {
      drinking = [];
    }
    this.setState({drinking:drinking, drinking_important: profile.userdata_prof_partner_drinking_important});

    let gambling;
    if (profile.userdata_prof_partner_gambling) {
      if (profile.userdata_prof_partner_gambling === '問わない') {
        gambling = [];
      }
      else {
        gambling = profile.userdata_prof_partner_gambling.split(',');
      }
    }
    else {
      gambling = [];
    }
    this.setState({gambling:gambling, gambling_important: profile.userdata_prof_partner_gambling_important});

    let pet;
    if (profile.userdata_prof_partner_pet) {
      if (profile.userdata_prof_partner_pet === '問わない') {
        pet = [];
      }
      else {
        pet = profile.userdata_prof_partner_pet.split(',');
      }
    }
    else {
      pet = [];
    }
    this.setState({pet:pet, pet_important: profile.userdata_prof_partner_pet_important});

    let academic;
    if (profile.userdata_prof_partner_academic) {
      if (profile.userdata_prof_partner_academic === '問わない') {
        academic = [];
      }
      else {
        academic = profile.userdata_prof_partner_academic.split(',');
      }
    }
    else {
      academic = [];
    }
    this.setState({academic:academic, academic_important: profile.userdata_prof_partner_academic_important});

    let job;
    if (profile.userdata_prof_partner_job) {
      if (profile.userdata_prof_partner_job === '問わない') {
        job = [];
      }
      else {
        job = profile.userdata_prof_partner_job.split(',');
      }
    }
    else {
      job = [];
    }
    this.setState({job:job, job_important: profile.userdata_prof_partner_job_important});

    let income;
    if (profile.userdata_prof_partner_income) {
      if (profile.userdata_prof_partner_income === '問わない') {
        income = [];
      }
      else {
        income = profile.userdata_prof_partner_income.split(',');
      }
    }
    else {
      income = [];
    }
    this.setState({income:income, income_important: profile.userdata_prof_partner_income_important});

    this.setState({datetime:new Date()});
  }


  _checkboxChange(stateKey, value) {
		if (this.state.[stateKey].includes(value)) {
      let nextState = this.state.[stateKey].filter( (arr) => { return arr !== value } );
      if (nextState.length === 0) {
        this.setState({ [stateKey + '_important']: 0 });
      }
      this.setState({ [stateKey]: nextState });
		}
    else {
      let nextState = [];
      profileItem.[stateKey].forEach( (item) => {
        if ([...this.state.[stateKey], value].includes(item.ja)) {
    			nextState.push(item.ja);
    		}
      })
      this.setState({ [stateKey]: nextState });
		}
  }

  _importantChange(stateKey) {
		if (this.state.[stateKey + '_important'] === 1) {
      this.setState({ [stateKey + '_important']: 0 });
		}
    else {
			this.setState({ [stateKey + '_important']: 1 });
		}
  }

  _towanai(stateKey) {
    this.setState({ [stateKey]: [] });
    this.setState({ [stateKey + '_important']: 0 });
  }

  _ageSelectChange(low, high) {
    if (low > high) {
      this.setState({age:[high, low]});
    }
    else {
      this.setState({age:[low, high]});
    }
  }

  _heightSelectChange(low, high) {
    if (low > high) {
      this.setState({height:[high, low]});
    }
    else {
      this.setState({height:[low, high]});
    }
  }

  _saveSubmit() {
    this.props.myProfilePartnerSave(this.state, (data) => {
      if (this.props.location.pathname.match(/^\/new\//)) {
        var seaerchObj = {
          age: {
            low: this.state.age[0],
            high: this.state.age[1],
          },
          distance: 0,
          proof: [],
          photo: [],
          recentSignin: [],
          community: [],
          keyword: '',
          name: '',
          compatibilityPoint: 0,
          characterPoint: 0,
          loginLimit: 90,
          region: this.state.region,
          marriage: [],
          job: [],
          academic: [],
          lifestyle: [],
          height: {
            low: 120,
            high: 230,
          },
          style: [],
          association: [],
          child: [],
          smorking: [],
          drinking: [],
          gambling: [],
          pet: [],
          blood: [],
          constellation: [],
          income: [],
          personality: [],
          opposite: [],
        };
        localStorage.setItem('SearchCondition', JSON.stringify(seaerchObj));

        this.props.history.push('/new/comment/');
      }
      else {
        this.props.history.push('/my/#myProfilePartnerBox');
      }
    })
  }

  render() {

      let saveVisible;
      if (
        (this.state.age[0]) &&
        (this.state.age[1]) &&
        (this.state.region) &&
        (this.state.style) &&
        (this.state.height[0]) &&
        (this.state.height[1]) &&
        (this.state.association) &&
        (this.state.marriage) &&
        (this.state.child) &&
        (this.state.lifestyle) &&
        (this.state.smorking) &&
        (this.state.drinking) &&
        (this.state.gambling) &&
        (this.state.pet) &&
        (this.state.academic) &&
        (this.state.job) &&
        (this.state.income)
      ) {
        saveVisible = true;
      }
      else {
        saveVisible = false;
      }

      return (
        <div>
        {
          (this.props.location.pathname.match(/^\/new\//)) ? (
            <div>
              <PartMyProfileStep step={1} />
              <h1 align='center'>パートナーへの希望</h1>
            </div>
          ) : (
              <PartPageTitle
                title={'パートナーへの希望'}
                onback={ '/my/' }
              />
            )
          }

          <div align='center' style={{color:'#666',fontSize:'0.9em'}}>
            パートナーへの希望条件を選択してください<br/>
            大切な条件には「重要」も選択してください
          </div>

          <div style={{maxWidth:'600px',margin:'auto'}}>
            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.age_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>年齢</h2>

              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  textAlign:'center',
                  alignItems:'center',
                  justifyContent: 'center'
                }}
              >
                <div>
                  <FormControl variant="outlined">
                    <Select
                      size="small"
                      style={{fontSize:'1.2em'}}
                      value={this.state.age[0]}
                      onChange={ (event) => this._ageSelectChange(event.target.value, this.state.age[1]) }
                    >
                      {
                        profileItem.age.map((value, index) => {
                          return (<MenuItem key={value} value={value} style={{fontSize:'1.2em'}}>{value}</MenuItem>);
                        })
                      }
                    </Select>
                  </FormControl>
                </div>
                <div>
                  &nbsp;〜&nbsp;
                </div>
                <div>
                  <FormControl variant="outlined">
                    <Select
                      size="small"
                      style={{fontSize:'1.2em'}}
                      value={this.state.age[1]}
                      onChange={ (event) => this._ageSelectChange(this.state.age[0], event.target.value) }
                    >
                      {
                        profileItem.age.map((value, index) => {
                          return (<MenuItem key={value} value={value} style={{fontSize:'1.2em'}}>{value}</MenuItem>);
                        })
                      }
                    </Select>
                  </FormControl>

                </div>
                <div>
                  &nbsp;才
                </div>
              </div>
              <div style={{margin:'20px'}}>
                <Slider
                  value={this.state.age}
                  onChange={ (e, value) => this.setState({age: value}) }
                  valueLabelDisplay="auto"
                  min={18}
                  max={90}
                  style={{width:'100%'}}
                />
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.age_important === 1)}
                  click={ () => this._importantChange('age') }
                  style={{margin:"3px"}}
                >
                  <span> 重要</span>
                </PartCheckbox>
              </div>

            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.region_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>地域</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
              {
                profileItem.region_group.map((groupValue, groupIndex) => (
                  <div key={groupIndex}>
                    {
                      profileItem.region.filter(value => value.group === groupValue.ja).map( (value, index) =>
                        <PartCheckbox
                          key={index}
                          value={value.ja}
                          checked={this.state.region.includes(value.ja)}
                          click={ (value) => this._checkboxChange('region', value) }
                          style={{margin:"3px"}}
                        >
                          <span>{value.ja.replace(/(県)|(府)|(海外-)/g, "")}</span>
                        </PartCheckbox>
                      )
                    }
                  </div>
                ))
              }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.region_important === 1)}
                  click={ () => this._importantChange('region') }
                  style={{margin:"3px"}}
                  disabled={(this.state.region.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.region.length === 0) ? true : false}
                  click={ () => this._towanai('region') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>

              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.style_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>体型</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.style.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.style.includes(value.ja)}
                      click={ (value) => this._checkboxChange('style', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.style_important === 1)}
                  click={ () => this._importantChange('style') }
                  style={{margin:"3px"}}
                  disabled={(this.state.style.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.style.length === 0) ? true : false}
                  click={ () => this._towanai('style') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.height_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>身長</h2>

              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  textAlign:'center',
                  alignItems:'center',
                  justifyContent: 'center'
                }}
              >
                <div>
                  <FormControl variant="outlined">
                    <Select
                      size="small"
                      style={{fontSize:'1.2em'}}
                      value={this.state.height[0]}
                      onChange={ (event) => this._heightSelectChange(event.target.value, this.state.height[1]) }
                    >
                      {
                        profileItem.height.map((value, index) => {
                          return (<MenuItem key={value} value={value} style={{fontSize:'1.2em'}}>{value}</MenuItem>);
                        })
                      }
                    </Select>
                  </FormControl>
                </div>
                <div>
                  &nbsp;〜&nbsp;
                </div>
                <div>
                  <FormControl variant="outlined">
                    <Select
                      size="small"
                      style={{fontSize:'1.2em'}}
                      value={this.state.height[1]}
                      onChange={ (event) => this._heightSelectChange(this.state.height[0], event.target.value) }
                    >
                      {
                        profileItem.height.map((value, index) => {
                          return (<MenuItem key={value} value={value} style={{fontSize:'1.2em'}}>{value}</MenuItem>);
                        })
                      }
                    </Select>
                  </FormControl>
                </div>
                <div>
                  &nbsp;cm
                </div>
              </div>
              <div style={{margin:'20px'}}>
                <Slider
                  value={this.state.height}
                  onChange={ (e, value) => this.setState({height: value}) }
                  valueLabelDisplay="auto"
                  min={120}
                  max={230}
                  style={{width:'100%'}}
                />
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.height_important === 1)}
                  click={ () => this._importantChange('height') }
                  style={{margin:"3px"}}
                >
                  <span> 重要</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.association_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>交際希望</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.association.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.association.includes(value.ja)}
                      click={ (value) => this._checkboxChange('association', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.association_important === 1)}
                  click={ () => this._importantChange('association') }
                  style={{margin:"3px"}}
                  disabled={(this.state.association.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.association.length === 0) ? true : false}
                  click={ () => this._towanai('association') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.marriage_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>結婚歴</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.marriage.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.marriage.includes(value.ja)}
                      click={ (value) => this._checkboxChange('marriage', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.marriage_important === 1)}
                  click={ () => this._importantChange('marriage') }
                  style={{margin:"3px"}}
                  disabled={(this.state.marriage.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.marriage.length === 0) ? true : false}
                  click={ () => this._towanai('marriage') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.lifestyle_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>生活</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.lifestyle.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.lifestyle.includes(value.ja)}
                      click={ (value) => this._checkboxChange('lifestyle', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.lifestyle_important === 1)}
                  click={ () => this._importantChange('lifestyle') }
                  style={{margin:"3px"}}
                  disabled={(this.state.lifestyle.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.lifestyle.length === 0) ? true : false}
                  click={ () => this._towanai('lifestyle') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.child_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>子供</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.child.map((value, index) =>
                    <div key={index}>
                      <PartCheckbox
                        value={value.ja}
                        checked={this.state.child.includes(value.ja)}
                        click={ (value) => this._checkboxChange('child', value) }
                        style={{margin:"3px"}}
                      >
                        <span>{value.ja}</span>
                      </PartCheckbox>
                    </div>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.child_important === 1)}
                  click={ () => this._importantChange('child') }
                  style={{margin:"3px"}}
                  disabled={(this.state.child.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.child.length === 0) ? true : false}
                  click={ () => this._towanai('child') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.smorking_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>タバコ</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.smorking.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.smorking.includes(value.ja)}
                      click={ (value) => this._checkboxChange('smorking', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.smorking_important === 1)}
                  click={ () => this._importantChange('smorking') }
                  style={{margin:"3px"}}
                  disabled={(this.state.smorking.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.smorking.length === 0) ? true : false}
                  click={ () => this._towanai('smorking') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.drinking_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>お酒</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.drinking.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.drinking.includes(value.ja)}
                      click={ (value) => this._checkboxChange('drinking', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.drinking_important === 1)}
                  click={ () => this._importantChange('drinking') }
                  style={{margin:"3px"}}
                  disabled={(this.state.drinking.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.drinking.length === 0) ? true : false}
                  click={ () => this._towanai('drinking') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.gambling_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>ギャンブル</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.gambling.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.gambling.includes(value.ja)}
                      click={ (value) => this._checkboxChange('gambling', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.gambling_important === 1)}
                  click={ () => this._importantChange('gambling') }
                  style={{margin:"3px"}}
                  disabled={(this.state.gambling.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.gambling.length === 0) ? true : false}
                  click={ () => this._towanai('gambling') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.pet_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>ペット</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.pet.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.pet.includes(value.ja)}
                      click={ (value) => this._checkboxChange('pet', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.pet_important === 1)}
                  click={ () => this._importantChange('pet') }
                  style={{margin:"3px"}}
                  disabled={(this.state.pet.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.pet.length === 0) ? true : false}
                  click={ () => this._towanai('pet') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.academic_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>学歴</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.academic.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.academic.includes(value.ja)}
                      click={ (value) => this._checkboxChange('academic', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.academic_important === 1)}
                  click={ () => this._importantChange('academic') }
                  style={{margin:"3px"}}
                  disabled={(this.state.academic.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.academic.length === 0) ? true : false}
                  click={ () => this._towanai('academic') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.job_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>仕事</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.job.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.ja}
                      checked={this.state.job.includes(value.ja)}
                      click={ (value) => this._checkboxChange('job', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.job_important === 1)}
                  click={ () => this._importantChange('job') }
                  style={{margin:"3px"}}
                  disabled={(this.state.job.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.job.length === 0) ? true : false}
                  click={ () => this._towanai('job') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

            <Box boxShadow={2} style={{margin:"15px",padding:"10px",background:(this.state.income_important === 1) ? "#fbf1f7" : "#FFF"}}>
              <h2 align='center'>年収</h2>
              <div align='center' style={{color:"#666"}}>複数選択できます</div>
              <div>
                {
                  profileItem.income.map((value, index) =>
                  <div key={index}>
                    <PartCheckbox
                      value={value.ja}
                      checked={this.state.income.includes(value.ja)}
                      click={ (value) => this._checkboxChange('income', value) }
                      style={{margin:"3px"}}
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  </div>
                  )
                }
              </div>
              <div align='center'>
                <PartCheckbox
                  value={1}
                  checked={(this.state.income_important === 1)}
                  click={ () => this._importantChange('income') }
                  style={{margin:"3px"}}
                  disabled={(this.state.income.length === 0) ? true : false}
                >
                  <span> 重要</span>
                </PartCheckbox>
                &nbsp;
                <PartCheckbox
                  value={1}
                  checked={(this.state.income.length === 0) ? true : false}
                  click={ () => this._towanai('income') }
                  style={{margin:"3px"}}
                >
                  <span> 問わない</span>
                </PartCheckbox>
              </div>
            </Box>

          </div>
          <div style={{height:'80px',width:'100%'}}></div>

          {
            (saveVisible) && (
              <div style={{position:'fixed',bottom:'0',left:'0px',width:'100%' ,zIndex:'101'}}>
                <div style={{maxWidth:'600px', margin:'auto', background:'rgba(0,0,0,0.3)'}}>
                  <div style={{padding:'10px'}}>
                    <Button
                      variant="contained"
                      color='primary'
                      onClick={ () => this._saveSubmit() }
                      style={{width: '100%', fontSize:'1.2em'}}
                    >
                      パートナーへの希望を登録する
                    </Button>
                  </div>
                </div>
              </div>
            )
          }

        </div>
      )


  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
